module.exports = __webpack_public_path__ + "static/img/logo69.e14911f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo69.png
// module id = +WFi
// module chunks = 1